import * as React from 'react';
import { FC, createElement } from 'react';
import { Card, Typography, Divider } from '@material-ui/core';
import { Box } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { ReactNode } from 'react';


interface Props {
    icon: FC<any>;
    title?: string;
    subtitle?: string | number;
    children?: ReactNode;
}

const useStyles = makeStyles(theme => ({
    card: {
        minHeight: 52,
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        '& a': {
            textDecoration: 'none',
            color: 'inherit',
        },
    },
    main: (props: Props) => ({
        overflow: 'inherit',
        padding: 16,
        background:'',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& .icon': {
            color: theme.palette.type === 'dark' ? 'inherit' : '#2E8BC0',
        },
    }),
    title: {},
}));

const DataCard = (props: Props) => {
    const { icon, title, subtitle ,children } = props;
    const classes = useStyles(props);
    return (
        <Card className={classes.card} style={{boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px'}}>
                <div className={classes.main}>
                    <Box width="3em" className="icon">
                        {createElement(icon, { fontSize: 'large' })}
                    </Box>
                    <Box textAlign="right">
                        <Typography
                            className={classes.title}
                            color="textSecondary"
                        >
                            {title}
                        </Typography>
                        <Typography variant="h5" component="h2">
                            {subtitle || ' '}
                        </Typography>
                    </Box>
                </div>
            {children && <Divider />}
            {children}
        </Card>
    );
};

export default DataCard;
